export default {
  'Difficulty level': 'Poziom trudności',
  'Your bet': 'Zakład',
  'Start game': 'Graj',
  'Take prize': 'Podejmij',
  'Try again': 'Spróbuj ponownie',
  Bet: 'Zakład',
  Profit: 'Zysk',
};
